import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed, toRefs } from 'vue';
import sanitizeHtml from 'sanitize-html';


export default /*#__PURE__*/_defineComponent({
  __name: 'DKRichTextHtml',
  props: {
    html: {}
  },
  setup(__props: any) {

const props = __props;

const { html } = toRefs(props);

const sanitizedHtml = computed<string>(() =>
  sanitizeHtml(html.value, {
    allowedAttributes: {
      th: ['style', 'rowspan', 'colspan'],
      td: ['style', 'rowspan', 'colspan'],
      span: ['style'],
      a: ['href', 'target', 'rel'],
    },
    allowedStyles: {
      '*': {
        'text-align': [/^left$/, /^right$/, /^center$/],
        'text-decoration': [/^underline$/],
      },
      th: {
        width: [/$/],
        'vertical-align': [/$/],
      },
      td: {
        width: [/$/],
        'vertical-align': [/$/],
      },
    },
  })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { innerHTML: sanitizedHtml.value }, null, 8, _hoisted_1))
}
}

})